<!-- Cart Drawer Backdrop -->
<div 
  class="cart-drawer-backdrop" 
  [class.open]="isOpen"
  (click)="onBackdropClick($event)">
</div>

<!-- Cart Drawer Sidebar -->
<div class="cart-drawer" [class.open]="isOpen">
  <div class="cart-drawer-content">
    <!-- Cart Header -->
    <div class="cart-drawer-header">
      <div class="cart-header-left">
        <span class="material-icons-outlined cart-icon">shopping_cart</span>
        <h2 class="cart-title">Cart ({{cartListDetails?.length || 0}})</h2>
      </div>
      <button 
        class="cart-close-btn" 
        (click)="closeDrawer()"
        aria-label="Close cart">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Cart Items Container -->
    <div class="cart-items-container">
      <!-- Hide empty state while cart data is loading to avoid flash -->
      <ng-container *ngIf="!isCartLoading">
        <ng-container *ngIf="cartListDetails?.length; else emptyCart">
          <div class="cart-item-list">
            <div 
              class="cart-item-card" 
              *ngFor="let item of cartListDetails; let i = index">

              <!-- Product Image with Delete Button Overlay -->
              <div 
                class="cart-item-image"
                (click)="goToProduct(item?.productId)"
                style="cursor: pointer;">
                <button 
                  class="cart-item-delete"
                  (click)="removeCartItem(item._id, i); $event.stopPropagation()"
                  aria-label="Remove item">
                  <i class="fa fa-times"></i>
                </button>
                <img 
                  [src]="item?.productId?.thumbnail || '/assets/images/placeholder.png'" 
                  [alt]="item?.productId?.productName"
                  loading="lazy">
              </div>

              <!-- Product Details -->
              <div class="cart-item-details">
                <h3 
                  class="cart-item-name"
                  (click)="goToProduct(item?.productId)"
                  style="cursor: pointer;">
                  {{item?.productId?.productName}}
                </h3>
                <p
                  class="cart-item-sku"
                  *ngIf="item?.productId?.sku || item?.productId?.productCode || item?.productId?.catCode">
                  SKU: {{item?.productId?.sku || item?.productId?.productCode || item?.productId?.catCode}}
                </p>

                <!-- Size / Value -->
                <div 
                  class="cart-item-size" 
                  *ngIf="item?.priceSizeDetails?.value || item?.priceSizeDetails?.unit">
                  {{item?.priceSizeDetails?.value}} {{item?.priceSizeDetails?.unit}}
                </div>
                
                <!-- Price -->
                <div class="cart-item-price">
                  {{getPrice((item?.isDealActive ? item?.dealPrice : item?.priceSizeDetails?.price) | currency:"ZAR":"R")}}
                </div>

                <!-- Error Message -->
                <div class="cart-item-error" *ngIf="erorMessageArr[i]">
                  {{erorMessageArr[i]}}
                </div>
              </div>

              <!-- Quantity Controls on the right -->
              <div class="cart-item-quantity-column">
                <div class="cart-item-quantity">
                  <button 
                    class="quantity-btn minus"
                    type="button"
                    [disabled]="item.quantity <= 1"
                    (click)="updateCartValue(item._id, item.priceSizeDetails, item.quantity - 1, item.quantity, i, item?.availableQuantity || item?.productId?.availableQuantity || 999)"
                    aria-label="Decrease quantity">
                    <span class="quantity-icon">−</span>
                  </button>
                  <span class="quantity-value">{{item?.quantity}}</span>
                  <button 
                    class="quantity-btn plus"
                    type="button"
                    (click)="updateCartValue(item._id, item.priceSizeDetails, item.quantity + 1, item.quantity, i, item?.availableQuantity || item?.productId?.availableQuantity || 999)"
                    aria-label="Increase quantity">
                    <span class="quantity-icon">+</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- Empty Cart State -->
      <ng-template #emptyCart>
        <div class="cart-empty-state">
          <i class="fa fa-shopping-cart empty-icon"></i>
          <p class="empty-text">Your cart is empty</p>
          <button class="empty-cta-btn" (click)="continueShopping()">
            Continue Shopping
          </button>
        </div>
      </ng-template>
    </div>

    <!-- Bottom Section (Sticky) -->
    <div class="cart-drawer-footer" *ngIf="cartListDetails?.length">
      <!-- Delivery Options (Drawer) -->
      <div class="drawer-delivery" *ngIf="optionList && optionList.length > 0">
        <div class="drawer-delivery-label">
          <span class="material-icons-outlined delivery-icon">local_shipping</span>
          <span class="drawer-delivery-title">Delivery Options</span>
        </div>
        <div class="drawer-delivery-select-wrapper">
          <select
            class="drawer-delivery-select"
            [ngModel]="selectedDeliveryOption?.deliveryType"
            (ngModelChange)="onDeliverySelectChange($event)">
            <option [value]="null" disabled>Select delivery option</option>
            <option 
              *ngFor="let option of optionList" 
              [value]="option.deliveryType">
              {{option.deliveryOption}} - {{option.description}} - {{option.deliveryAmount ? getPrice(option.deliveryAmount | currency:'ZAR':'R') : 'Free'}}
            </option>
          </select>
        </div>
      </div>

      <!-- Total -->
      <div class="cart-total-section">
        <span class="total-label">Total:</span>
        <span class="total-amount">{{getPrice(getCartTotal() | currency:"ZAR":"R")}}</span>
      </div>

      <!-- Action Buttons -->
      <div class="cart-action-buttons">
        <!-- Proceed to Checkout -->
        <button 
          class="btn-checkout"
          (click)="proceedToCheckout()">
          <span>Proceed to Checkout</span>
          <i class="fa fa-arrow-right"></i>
        </button>

        <!-- View Cart -->
        <button 
          class="btn-view-cart"
          (click)="viewCart()">
          <span class="material-icons-outlined btn-view-cart-icon">shopping_cart</span>
          <span>View Cart</span>
        </button>
      </div>

      <!-- Footer Links -->
      <div class="cart-footer-links">
        <a 
          class="continue-shopping-link" 
          (click)="continueShopping()">
          Continue Shopping
        </a>
        <a 
          class="clear-all-link" 
          (click)="clearAllItems()">
          Clear all items
        </a>
      </div>
    </div>
  </div>
</div>

